import heroImage from '../hero.jpg';
import FeaturedFilm from '../film';
import comingSoonBg from '../image.jpg';
import FilmsSection from '../sec1';
import BookSection from '../sec2';
import LastSection from '../lastsection';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import missionIcon from '../mission-svg.svg';
import golIcon from '../goal-svg.svg';
import awardIcon from '../award-icon.svg';
import Buttons from './ui/Button/Button';
import Footer from './Footer';

export const Home = () => {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({
    // target: heroRef,
    // offset: ['start start', 'end start'],
  });
  const rawPerspective = useTransform(scrollYProgress, [0, 1], [1200, 600]);
  const perspective = useTransform(rawPerspective, (value) => `${value}px`);

  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.85]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0.5]);

  return (
    <>
      <main className="font-serif w-full max-w-full bg-[#0d0d0d]">
        {/* "Landing" */}
        {/* <Route path="/"> */}
        {/* Hero Section */}
        <motion.section
          id="home"
          ref={heroRef}
          className="sticky top-0 min-h-[990px] sm:min-h-[70vh] md:min-h-screen bg-cover bg-center flex items-center justify-center pt-24 sm:pt-20 relative
    before:content-[''] before:absolute before:left-0 before:top-0 before:w-full before:h-full before:bg-[#1B0C02] before:opacity-[.62]"
          style={{
            backgroundImage: `url(${heroImage})`,
            perspective,
            scale,
            willChange: 'transform',
            opacity,
          }}
        >
          <div className="text-center px-2 sm:px-4 md:px-6 w-full">
            <h1
              className="font-cinzel text-white uppercase font-extrabold drop-shadow-lg leading-tight tracking-tight
            text-[40px] md:text-[70px] lg:text-[90px] leading-[98.2%] max-w-8xl mx-auto tracking-[-0.04em]"
            >
              <span className="block">CREATING BOLD STORIES</span>
              <span className="block">THAT REDEFINE DEAF</span>
              <span className="block">REPRESENTATION</span>
            </h1>
          </div>
        </motion.section>
        {/* Welcome Section */}
        <section className="relative bg-[#421B03] text-white py-16 px-5 sm:px-0 md:py-20 text-center efore:content-[''] before:absolute before:bottom-0 before:left-0 before:w-full before:h-[124px] before:bg-[linear-gradient(183.47deg,_rgba(0,0,0,0)_27.69%,_#2F1302_157.12%)] z-10">
          <div className="max-w-[1200px] mx-auto">
            <h2 className="font-cinzel text-[26px] sm:[44px] md:text-[44px] leading-[100%] font-bold mb-6 uppercase text-white">
              Welcome to Mermaid Signature Production
            </h2>
            <p className="font-ubuntu text-[17px] sm-text-[26px] md:text-[30px] leading-[132%] text-[#fff] mt-[36px] sm:mt-[50px]">
              Mermaid Signature Production is a Deaf-owned, independent film
              company breaking barriers in Hollywood. We craft powerful stories
              that center Deaf experiences, <br />
              language, and culture—led by Deaf creatives both in front of and
              behind the camera. <br />
              This isn't just inclusive cinema. This is what authentic, Deaf-led
              storytelling means: <br />
              bold, unapologetic, and visionary.
            </p>
          </div>
        </section>
        {/* Featured Film Section */}
        <FeaturedFilm />
        {/* {coming soon} */}
        {/* {coming soon} */}
        <section
          className="relative bg-cover bg-center text-white text-center pt-16 sm:pt-15 pb-14 sm:pb-15 px-5 sm:px-0"
          style={{ backgroundImage: `url(${comingSoonBg})` }}
        >
          <div className="max-w-[1050px] mx-auto">
            <h2 className="font-cinzel text-[26px] sm:text-[38px] md:[44px] font-bold leading-[120%] uppercase">
              Strength in Silence — A Groundbreaking Thriller from the Deaf
              Perspective. A story of survival, identity, and revolution
            </h2>

            <p className="font-cinzel mt-[44px] text-[24px] sm:text-[36px] md:text-[40px] font-bold leading-[120%] uppercase">
              Coming Soon To Major Studios
            </p>

            {/* <button className="font-cinzel mt-10 bg-[#F2BA35] text-base text-white font-semibold px-4 sm:px-6 min-w-[180px] leading-[52px] rounded-full shadow-lg hover:bg-white hover:text-[#F2BA35] transition">
            Watch Teaser
          </button> */}

            <div className="mt-10 flex justify-center">
              <Buttons label="Join Us" />
            </div>
          </div>
        </section>
        <section
          id="about"
          className="scroll-mt-24 bg-[#2C4728] text-white px-5 sm:px-8 py-16 sm:py-24 relative"
        >
          {/* Decorative vertical lines */}
          <div className="absolute inset-0 z-0 flex justify-between none sm:flex">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="w-[1px] bg-white h-full  opacity-[0.03]"
              />
            ))}
          </div>

          {/* Main Content */}
          <div className="relative z-10 max-w-[1260px] mx-auto space-y-24">
            {/* About & Description */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-12">
              <div>
                <h2 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel sticky top-[90px]">
                  ABOUT US
                </h2>
              </div>
              <div className="flex flex-col	gap-16	col-span-2	">
                <div>
                  <h3 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-cinzel font-bold mb-6 capitalize">
                    Production house description
                  </h3>
                  <p className="text-[22px] leading-[160%] font-light font-ubuntu opacity-80">
                    Mermaid Signature Production is dedicated to creating
                    authentic cinematic experiences that spotlight Deaf
                    perspectives and talent. Our mission is to transform the
                    entertainment industry by bringing powerful, Deaf-led
                    stories to audiences around the world.
                  </p>
                </div>

                <div>
                  <h3 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel mb-6 capitalize">
                    Antoinette Abbamonte Bio & Vision Statement:
                  </h3>
                  <p className="text-[22px] leading-[160%] font-light font-ubuntu opacity-80">
                    Antoinette Abbamonte is a pioneering Deaf actor, creative
                    producer, and visionary storyteller. She is the founder of
                    Mermaid Signature Production, a Deaf-owned film company
                    dedicated to authentic representation. With a long history
                    of elevating Deaf stories on stage and screen, Antoinette
                    envisions a future where Deaf talent leads and Deaf
                    narratives are told with authenticity, nuance, and pride.
                    Her work breaks down barriers, challenges stereotypes, and
                    paves the way for generations of Deaf creatives to thrive in
                    the entertainment industry.
                  </p>
                </div>
              </div>
            </div>

            {/* Bio Section */}

            {/* Mission & Vision */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <img src={missionIcon} alt="Mission Statement" />
                <h3 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel my-8 capitalize">
                  Mission Statement
                </h3>
                <p className="text-[22px] leading-[160%] font-light font-ubuntu opacity-80">
                  At Mermaid Signature Production, we create authentic cinematic
                  experiences that center on Deaf perspectives, stories, and
                  talent. Our mission is to transform the entertainment industry
                  by amplifying bold, Deaf-led narratives and connecting them
                  with audiences worldwide.
                </p>
              </div>

              <div>
                <img src={golIcon} alt="Vision Statement" />
                <h3 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel my-8 capitalize">
                  Vision Statement
                </h3>
                <p className="text-[22px] leading-[160%] font-light font-ubuntu opacity-80">
                  To be a global leader in Deaf-centered storytelling, where
                  every production challenges industry norms and opens doors for
                  Deaf artists to lead. Our long-term vision is to build a
                  studio where Deaf expression flourishes, inspiring generations
                  to come.
                </p>
              </div>
            </div>

            {/* Awards Section */}
            <div>
              <h3 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel mb-8 capitalize">
                Awards & Milestones
              </h3>
              <div className="flex lg:justify-end justify-start gap-4 w-full ">
                <div className="flex flex-col gap-8 lg:w-[70%] w-full">
                  {[
                    'Since August featured in international festivals for its all-ASL dialogue',
                    'Featured in Entertainment Weekly, Film Monthly, and Variety',
                    'Strength in Silence in development with leading Deaf talent',
                    'Collaborations with Ged Dickersin and other industry leaders',
                  ].map((text, i) => (
                    <div
                      key={i}
                      className="flex flex-row md:items-center lg:gap-16 gap-5"
                    >
                      <div className="flex justify-center md:justify-end lg:w-[82px] w-[70px]">
                        <img src={awardIcon} alt={text} />
                      </div>
                      {/* <div className="bg-[#264021] border-2 border-white/20 lg:rounded-[30px] rounded-[10px] lg:px-[38px] lg:py-8 p-2 shadow-inner lg:text-[28px] lg:leading-[120%] text-[15px] font-ubuntu bg-[linear-gradient(138.77deg,rgba(255,255,255,0.22)_5.93%,rgba(255,255,255,0)_37.62%)] transition-all duration-400 ease-ease-custom hover:bg-[radial-gradient(50%_50%_at_50%_0%,_rgba(255,255,255,0.15)_2.21%,_rgba(255,255,255,0)_100%)]">
                      {text}
                    </div> */}

                      <div className="relative bg-[#264021] border-2 border-white/20 lg:rounded-[30px] rounded-[10px] lg:px-[38px] lg:py-8 p-2 shadow-inner lg:text-[28px] lg:leading-[120%] text-[15px] font-ubuntu overflow-hidden group">
                        <div className="absolute inset-0 bg-[linear-gradient(138.77deg,rgba(255,255,255,0.22)_5.93%,rgba(255,255,255,0)_37.62%)] transition-opacity duration-400 ease-ease-custom group-hover:opacity-0"></div>
                        <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_0%,_rgba(255,255,255,0.15)_2.21%,_rgba(255,255,255,0)_100%)] opacity-0 transition-opacity duration-400 ease-ease-custom group-hover:opacity-100"></div>
                        <div className="relative z-10">{text}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="films"
          className="scroll-mt-24 relative z-10 bg-[#4a1e00] px-5 sm:px-6 py-6 sm:py-16 lg:py-10"
        >
          <FilmsSection />
          <div
            id="film"
            className="scroll-mt-24 text-white pt-6 px-6 text-center relative z-[10]"
          >
            <div className="max-w-[1240px] mx-auto">
              {/* Description */}
              <h2 className="text-[34px] lg:text-[84px] leading-[120%] uppercase lg:capitalize font-bold font-cinzel sm:mb-4">
                Strength in Silence (2026)
              </h2>
              <p className="lg:text-[30px] text-[17px] lg:leading-[120%] font-light font-ubuntu opacity-50 mb-4 sm:mb-8 m-auto pt-2">
                Produced by Mermaid Signature Production, a Deaf-owned and
                Deaf-led independent film company committed to crafting
                original, thought-provoking stories that center Deaf characters,
                culture, and language.
              </p>
              <p className="lg:text-[30px] text-[17px] lg:leading-[120%] font-light font-ubuntu opacity-50 mb-4 sm:mb-8 m-auto pt-2">
                We collaborate with diverse creative voices to reimagine what
                authentic representation means in modern cinema and to challenge
                the norms of traditional storytelling. When silence becomes
                power, the revolution begins.
              </p>
              <p className="italic lg:text-[30px] text-[17px] lg:leading-[120%] font-light font-ubuntu opacity-50">
                Genre: Thriller | Status: In Development
              </p>
            </div>
          </div>
        </section>

        {/* film section */}

        <BookSection />
        <section className="scrollpress">
          <LastSection />
        </section>
      </main>
    </>
  );
};
